<!--  -->
<template>
  <div class="menu-wrap">
    <div
      class="menu-item-top"
      v-for="(item, index) in menuListData"
      :key="index"
    >
      <p class="item-top-wrap">
        <img :src="item.imgPath" alt="" />
        <span class="item-top-txt">{{ item.authName }}</span
        ><i class="el-icon-arrow-down"></i>
      </p>
      <ul class="sub-menu">
        <li
          class="level-1"
          @click="toPath(item1.authCode)"
          v-for="(item1, index1) in item.childList"
          :key="index1"
        >
          <img :src="item1.imgPath" alt="" />
          <p class="level-1-p">{{ item1.authName }}</p>
          <ul>
            <li
              class="level-2"
              v-for="item2 in item1.childList"
              :key="item2.authId"
              @click="toPath(item2.authCode)"
            >
              <span>{{ item2.authName }}</span>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuListData: {
      type: Array,
      default () {
        return [];
      },
    },
  },
  data () {
    return {};
  },

  components: {},

  computed: {},

  created () { },
  methods: {
    toPath (url) {
      window.open(url, "_blank");
    },
  },
};
</script>
<style lang='scss' scoped>
@import '@/assets/css/theme.scss';
.menu-wrap {
  display: flex;
  .menu-item-top {
    // margin-right: 24px;
    // width: 90px;
    padding: 0 12px;
    position: relative;
    cursor: pointer;
    text-align: center;
    .item-top-txt {
      font-size: 12px;
      color: #fff;
    }
    i {
      margin-left: 6px;
    }
    .sub-menu {
      // display: ;
      padding-bottom: 20px;
      display: none;
      flex-direction: column;
      right: 0;
      position: absolute;
      background: #fff;
      border-left: 1px solid #d9d9d9;
      border-bottom: 1px solid #d9d9d9;
      border-right: 1px solid #d9d9d9;
      box-shadow: 0px 3px 4px rgba(163, 163, 163, 0.25);
      z-index: 1000;
      min-width: max-content;
      .level-1 {
        min-width: 97px;
        margin-top: 10px;
        line-height: normal !important;
        box-sizing: border-box;
        padding: 0 10px;
        // min-width: 120px;
        display: flex;
        align-items: center;
        flex-shrink: 0;
        &:hover {
          p {
            color: $main-col;
          }
        }
        img {
          width: 16px;
          height: 18px;
          display: block;
          margin-right: 8px;
        }
        ul {
          text-align: left;
        }
        .level-1-p {
          color: #333;
          font-size: 14px;
          text-align: left;
        }
        .level-2 {
          padding: 0 20px;
          margin-top: 10px;
          span {
            color: #999;
            font-size: 12px;
          }
          &:hover {
            span {
              color: $main-col;
            }
          }
        }
      }
    }
  }
  .item-top-wrap {
    display: flex;
    align-items: center;
    img {
      width: 15px;
      height: 10px;
      display: block;
      margin-right: 8px;
    }
    i {
      color: #fff;
    }
  }
  :hover {
    background: #fff;
    color: #333;
    .sub-menu {
      display: flex;
    }
    .item-top-wrap {
      span {
        color: #333;
      }
      i {
        color: #333;
      }
    }
  }
}
</style>